import React from 'react';
import Image from 'next/legacy/image';
import Link from 'next/link';
import { StaticImageData } from 'next/image';

interface StateButtonProps {
  image: StaticImageData;
  state: string;
  link: string;
}

const StateButton: React.FC<StateButtonProps> = ({ image, state, link }) => {
  return (
    <Link
      href={link}
      className="bg-blue-100 hover:bg-blue-300 text-black flex items-center rounded h-12 w-40 md:w-44 shadow-sm no-underline"
    >
      <div className="flex items-center">
        <div className="h-10 w-10 text-blue-100 overflow-hidden">
          <Image src={image} alt={'EnergyPal solar installer in ' + state} />
        </div>
        <h4 className="text-black text-base ml-1 md:ml-2 my-auto">{state}</h4>
      </div>
    </Link>
  );
};

export default StateButton;
